import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDoneJobs } from 'hooks/useDoneJobs/useDoneJobs';
import { useTranslation } from 'react-i18next';
import Spinner from 'components/Spinner';
import JourneysList from 'components/JourneysList';
import { ROUTES } from 'utils/constants/routes';
import { useHistory } from 'react-router-dom';
import { Button } from '@ontruck/orc';

const DoneJobs = ({ className }) => {
  const {
    doneJobs,
    isLoadingInitialData,
    error,
    isLoadingMore,
    hasMore,
    size,
    setSize,
  } = useDoneJobs();
  const { t } = useTranslation('Jobs');
  let history = useHistory();

  const handleClick = useCallback(
    (id) =>
      history.push({
        pathname: `${ROUTES.DONE_DETAIL.DEFAULT}/${id}`,
        state: { backRoute: ROUTES.DONE },
      }),
    [history]
  );

  const renderDoneJobs = useCallback(() => {
    if (isLoadingInitialData) {
      return (
        <div className="done-jobs__loading" data-testid="done-jobs__spinner">
          <Spinner />
        </div>
      );
    }

    if (error) {
      return <div>{t('error')}</div>;
    }

    if (!doneJobs || doneJobs.length === 0) {
      return <div className="done-jobs__alert">{t('noDoneJobs')}</div>;
    }

    return (
      <div>
        <JourneysList
          journeys={doneJobs}
          parentClass="done-jobs"
          handleClick={handleClick}
          showPrice
          avoidOrdering
        />
        {!isLoadingMore && hasMore && (
          <div className="done-jobs__loadMore">
            <Button
              ghost
              text={t('loadMore')}
              onClick={() => {
                setSize(size + 1);
              }}
            />
          </div>
        )}
        {isLoadingMore && (
          <div
            className="done-jobs__loading"
            data-testid="done-jobs__spinner-more"
          >
            <Spinner />
          </div>
        )}
      </div>
    );
  }, [
    hasMore,
    isLoadingMore,
    setSize,
    size,
    error,
    isLoadingInitialData,
    doneJobs,
    t,
    handleClick,
  ]);

  return (
    <div className={className}>
      <div className="done-jobs">
        <div className="done-jobs__container">{renderDoneJobs()}</div>
      </div>
    </div>
  );
};

DoneJobs.propTypes = {
  className: PropTypes.string,
};

export default DoneJobs;
